
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","viewBox":"1 0 17 16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.729 2.02l1.384 3.813 3.868.019c.73.003 1.074.902.533 1.392l-2.926 2.653.875 3.62a.8.8 0 01-1.177.882L8.97 12.49l-3.301 1.907a.813.813 0 01-.277.1l-.093.009a.802.802 0 01-.81-.98l.833-3.639-2.885-2.646c-.535-.49-.191-1.384.535-1.39l3.824-.027 1.431-3.813a.789.789 0 01.264-.358c.014-.01.026-.02.038-.027a.772.772 0 01.418-.133h.028a.787.787 0 01.753.527zm-.755 2.61l-.002 6.137c.137 0 .274.036.397.107l2.101 1.209-.549-2.272a.8.8 0 01.24-.78l1.753-1.59-2.367-.01a.8.8 0 01-.748-.528L8.974 4.63z","fill":"#FF7950","fill-rule":"evenodd"}})])
          )
        }
      }
    